module.exports = __webpack_public_path__ + "static/media/pesca.a4cef109.jpg";